import React from 'react';
import type ProductsJsmOrganizationsList from '@jira/admin-pages__products-jsm-organizations-list/src/OrganizationsListPage.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyProductsJsmOrganizations = lazyForPaint<typeof ProductsJsmOrganizationsList>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-products-jsm-organizations-list", jiraSpaEntry: "async-products-jsm-organizations-list" */ '@jira/admin-pages__products-jsm-organizations-list/src/OrganizationsListPage.tsx'
		),
	),
);

const AsyncProductsJsmOrganizations = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProductsJsmOrganizations}
		pageId="products-jsm-organizations-list"
		shouldShowSpinner
	/>
);

export default AsyncProductsJsmOrganizations;
